<ng-container *ngIf="state$ | async as state">
  <div class="flyout2-column column-1"
       data-cy="navigation-flyout-column-1"
  >
    <ul class="structure">
      <li *ngFor="let category of navigation$ | async; index as i"
          [attr.aria-label]="category?.label"
          [attr.data-filtered]="!!(selectedFilter$ | async) ? 1 : 0"
          [attr.data-target]="category?.label"
          [class.open]="(selectedCategory$ | async)?.label === category?.label"
          data-cy="navigation-flyout-column-1-item"
          role="menuitem"
      >
        <ul *ngIf="category?.label === products || category?.label === applications"
            [class.selected-filter]="(activeFilter$ | async)"
            class="nav"
            data-cy="navigation-flyout-filters"
        >
          <li *ngFor="let filter of category?.children; index as i"
              [class.active]="(activeFilter$ | async)?.label === filter?.label"
              data-cy="navigation-flyout-filter-item"
          >
            <mb-link *ngIf="filter?.children?.length"
                     [dataColor]="orange"
                     [dataEventAction]="'Click Filter ' + filter?.label"
                     [dataEventLabel]="category?.label"
                     [dataFilter]="category?.label + ' ' + filter?.label"
                     [dataTarget]="category?.label?.toLocaleLowerCase() + '_' + category?.label?.toLocaleLowerCase() + '-filters_' + filter?.label"
                     [linkData]="{ uid: cmsLinkType.SPECIAL, text: filter?.label }"
                     (clickEvent)="filterClick.emit({ filter, event: $event })"
                     dataCy="navigation-flyout-filter-item-link"
                     dataEventCategory="TopNavi"
            ></mb-link>
            <mb-link *ngIf="!filter?.children?.length"
                     [dataEventAction]="'Click Filter ' + filter?.label"
                     [dataEventLabel]="category?.label"
                     [dataFilter]="category?.label + ' ' + (selectedFilter$ | async )?.label"
                     [linkData]="{ url: filter?.url, uid: 'content_link', text: filter?.label }"
                     (clickEvent)="triggerClose.emit($event)"
                     dataColor="corporate-orange"
                     dataCy="navigation-flyout-filter-item-link"
                     dataEventCategory="TopNavi"
                     styleClass="is-link"
            ></mb-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</ng-container>
